import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as AuthActions from './auth.actions';
import * as AuthSelectors from './auth.selectors';
import { SignupRequest } from '../models/signup-request.models';
import { PasswordresetemailRequest } from '../models/passwordresetemail-request.models';
import { PasswordresetRequest } from '../models/passwordreset-request.models';
import { VereinSmall } from '../../app/models/verein-small.models';


@Injectable()
export class AuthFacade {

  auth$ = this.authStore.select(AuthSelectors.authQuery);
  user$ = this.authStore.select(AuthSelectors.selectAuthUser);
  isLoggedIn$ = this.authStore.select(AuthSelectors.selectIsLoggedIn);
  isLoadingLogin$ = this.authStore.select(AuthSelectors.selectIsLoadingLogin);
  hasLoginError$ = this.authStore.select(AuthSelectors.selectLoginError);
  loggedInUser$ = this.authStore.select(AuthSelectors.selectAuthUser);

  session$ = this.authStore.select(AuthSelectors.selectSession);

  headerMenu2$ = this.authStore.select(AuthSelectors.getHeaderMenu2);
  selectHeaderMenu2FromRoot$ = this.authStore.select(AuthSelectors.selectHeaderMenu2FromRoot);

  constructor(private authStore: Store) { }

  login(username: string, password: string, rememberThisUser: boolean) {
    this.authStore.dispatch(AuthActions.login({ username, password, rememberThisUser }));
  }

  logout() {
    this.authStore.dispatch(AuthActions.logout());
  }

  signUp(logonName: string, password: string, passwordConfirm: string) {
    const signup: SignupRequest = {
      logonName: logonName,
      password: password,
      confirmPassword: passwordConfirm
    };
    this.authStore.dispatch(AuthActions.signup({ signUpRequest: signup }));
  }

  passwordResetEmail(email: string) {
    const passwordresetemail: PasswordresetemailRequest = {
      email: email
    };
    this.authStore.dispatch(AuthActions.passwordResetEmail({ passwordResetEmailRequest: passwordresetemail }));
  }

  passwordReset(newPassword: string, newPasswordConfirmed: string, mailToken: string) {
    const passwordreset: PasswordresetRequest = {
      newPassword: newPassword,
      newPasswordConfirm: newPasswordConfirmed,
      mailToken: mailToken
    };
    this.authStore.dispatch(AuthActions.passwordReset({ passwordResetRequest: passwordreset }));
  }

  getAuthUser() {
    this.authStore.dispatch(AuthActions.getAuthUserRequest());
  }

  refreshToken() {
    this.authStore.dispatch(AuthActions.refreshToken());
  }

  SelectGetGlobalData(name: string, path: string): any {
    let value: any;
    (this.authStore.select(AuthSelectors.getData(name, path))).subscribe(c => value = c);
    return value;
  }

  selectHeaderMenu2FromParentId(parentId: number) {
    return this.authStore.select(AuthSelectors.selectHeaderMenu2FromParentId(parentId));
  }
}
